import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-submit-error',
  templateUrl: './submit-error.component.html',
  styleUrls: ['./submit-error.component.css']
})
export class SubmitErrorComponent implements OnInit {

  dialog:any;

  constructor(
    private dialogRef: MatDialogRef<SubmitErrorComponent>,
    @Inject(MAT_DIALOG_DATA) data ) {
    this.dialog = data;    
   }

  ngOnInit() {
    console.log('SubmitErrorComponent', this.dialog);
  }

  close(){
    this.dialogRef.close();
  }
}
